import React, { Component } from 'react';
import './styles.css';
//import TagManager from 'react-gtm-module';

const URLSearchParams = require('url-search-params');

class Thanks extends Component {
	componentDidMount() {

		const urlParams = new URLSearchParams(window.location.search);

		//insert adform script
		let s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/';
		let x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);

		//Global site tag (gtag.js) - Google Ads: 652852675
		let gScript = document.createElement('script');
		gScript.type = 'text/javascript';
		gScript.async = true;
		gScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-652852675';
		let g = document.getElementsByTagName('script')[0];
		g.parentNode.insertBefore(gScript, g);

		//passing query string param on tracking function
		window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
		window._adftrack.push({
			pm: 307530,
			divider: encodeURIComponent('|'),
			pagename: encodeURIComponent('TYP_PREZZO GIUSTO_LEAD'),
			order: {
				sv52: urlParams.get('j')
			}
		});
		function gtag(){
			window.dataLayer.push(arguments);
		}
		gtag('event', 'conversion', { 'send_to': 'AW-652852675/miGaCJ7UzswBEMP7prcC' });
		// const tagManagerArgs = {
		// 	events: {
		// 		conversion: { 'send_to': 'AW-652852675/miGaCJ7UzswBEMP7prcC' }
		// 	}
		// };
		// TagManager.initialize(tagManagerArgs);
	}

	render() {
		//const urlParams = new URLSearchParams(window.location.search);
		// const { onFinish } = this.props;
		return (
			<div>
				<div className="thanks" {...this.props}>
					<div className="thanks-cont">
						<h3> Grazie! </h3>
						<div
							style={{
								height: '2vh'
							}}
						/>
						<p className="thanks-paragraph">
							{`
							Verrai ricontattato al più presto da un consulente TIM nelle seguenti fasce orarie:
							`}
						</p>
						<p className="thanks-paragraph">
							{`
							Dal lunedì alla domenica tra le 10:00 e le 22:00
							`}
						</p>
					</div>
				</div>
				<p style={{ margin: 0, padding: 0, border: 0 }}>
					<img src="https://track.adform.net/Serving/TrackPoint/?pm=307530&ADFPageName=TYP_PREZZO%20GIUSTO%20LEAD_GOOGLE&ADFdivider=|" width="1" height="1" alt="" />
				</p>
			</div>
		);
	}
}

export default Thanks;



// WEBPACK FOOTER //
// ./src/screens/Thanks/index.js